import BookieLogo from './bookie-logo';

export * from './bookie-logo';

export default BookieLogo;
